// extracted by mini-css-extract-plugin
export default {"groupEmptyState":"GroupEmptyState_groupEmptyState__kQ8+h"};